/**
 * Modules
 */
import Chart from 'chart.js';

const build =  () => {
	
	if($('#myChart').length < 1) {
		return false;
	}

	let ctx = $('#myChart');

	Chart.defaults.global.defaultFontColor = '#2a2a2a';
	Chart.defaults.global.defaultFontStyle = 'normal';
	Chart.defaults.global.defaultFontSize = 9;
	Chart.defaults.global.responsive = true;

	var myChart = new Chart(ctx, {
		type: 'radar',
		data: {
			labels: ctx.attr('data-labels').split(','),
			datasets: [{
				data: ctx.attr('data-values').split(','),
				fill: false,
				lineTension: 0,
				borderColor: 'rgba(230,0,6,1)',
				borderWidth: 5,
				pointBackgroundColor: 'rgba(230,0,6,0.75)',
				pointStyle: 'rect',
				pointRadius: 10,
				spanGaps: true
			}]
		},
		options: {
			layout: {
				padding: {
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}
			},
			legend: {
				display: false
			},
			scale: {
				angleLines: {
					display: true
				},
				ticks: {
					beginAtZero: true,
					suggestedMin: 1,
					suggestedMax: 4
					
				}
			},
			tooltips: {
				enabled: false
			}
		}
	});

};


/**
 * export methods
 */

export {
	build
}